import { RECEIVE_SERVICE_LEVEL_PRODUCTS_DATA } from "../actions/serviceLevelProductsActions";
import { RECEIVE_SERVICE_LEVEL_SPECIALTIES_DATA } from "../actions/serviceLevelSpecialtiesActions";

const initialState = {};

export default function serviceLevelContentReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_SERVICE_LEVEL_PRODUCTS_DATA:
      return {
        ...state,
        products: [...action.payload]
      };
    case RECEIVE_SERVICE_LEVEL_SPECIALTIES_DATA:
      return {
        ...state,
        specialties: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/serviceLevelContentReducer.js